var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZhWappen2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.91511,
    height: 18.05861,
    viewBox: "0 0 14.91511 18.05861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#150b00;stroke-width:.27841px;}.cls-2{fill:#2e66a9;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZH"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m14.7759,10.5298c0,4.0864-3.31,7.3896-7.3388,7.3896C3.4063,17.9194.1392,14.6162.1392,10.5405V.1392h14.6367v10.3906h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.4371,17.9194c2.3413,0,4.4336-1.18633,5.7827-3.02582L.1392.1392v9.96501c0,4.31668,3.2671,7.81519,7.2979,7.81519Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhWappen2);
export default __webpack_public_path__ + "static/media/zh-wappen-2.aec34d9a6fd639d9aefcc2fd818f766c.svg";
export { ForwardRef as ReactComponent };